import React from "react";
import { Reducer, MaterialStateType, MaterialDispatch } from "./reducer";

export const MaterialStateContext = React.createContext<MaterialStateType>({
  data: [],
});
export const MaterialDispatchContext = React.createContext<
  MaterialDispatch | undefined
>(undefined);

interface MaterialProviderProps {}

type MaterialProviderPropsType = React.PropsWithChildren<MaterialProviderProps>;

export const MaterialProvider: React.FC<MaterialProviderPropsType> = ({
  children,
}: MaterialProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {
    data: [],
  });
  return (
    <MaterialDispatchContext.Provider value={dispatch}>
      <MaterialStateContext.Provider value={state}>
        {children}
      </MaterialStateContext.Provider>
    </MaterialDispatchContext.Provider>
  );
};

export const useMaterialState = () => {
  const state = React.useContext(MaterialStateContext);
  return state;
};

export const useMaterialDispatch = () => {
  const dispatch = React.useContext(MaterialDispatchContext);
  return dispatch;
};
